import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";

import { getDescriptionMessage } from "@helpers/general";

import { kioskStore } from "@pages/Kiosk/store";

import "./index.css";

type AuthenticationErrorMainType = {
    isGodiaLoyalty: boolean;
    isCreateAnAccountSelected: boolean;
    isCreateAnAccountActive: boolean;
    isPhoneInvalid: boolean;
};

export default function AuthenticationErrorMain({
    isGodiaLoyalty,
    isCreateAnAccountSelected,
    isCreateAnAccountActive,
    isPhoneInvalid,
}: AuthenticationErrorMainType): JSX.Element {
    const {
        project: {
            template: { pages },
        },
        selectedAuthMode,
    } = useSnapshot(kioskStore);
    const descriptionMessage = getDescriptionMessage(
        isGodiaLoyalty,
        isCreateAnAccountSelected,
        isCreateAnAccountActive,
        isPhoneInvalid,
        selectedAuthMode
    );

    return (
        <div className="d-flex flex-column auth-main-container-title">
            {isGodiaLoyalty === false ? (
                <div className="d-flex justify-content-center align-items-center w-100">
                    <span className="auth-main-title">
                        {t(pages.subSteps[selectedAuthMode].name)}
                    </span>
                </div>
            ) : null}
            <div className="d-flex justify-content-center align-items-center text-center">
                <span className="auth-main-description">
                    {t(`${descriptionMessage}`)}
                </span>
            </div>
        </div>
    );
}
